import { User } from './user';

export class Token {

    id: number;
    value: string;
    created_at: string;
    user: User;

    constructor() {}


}
